module.exports = __webpack_public_path__ + "img/icons-socios.f3a52eb5.svg";